module.exports = __webpack_public_path__ + "img/contact7.08192011.jpg";